export default "__VITE_ASSET__zRTwJa89__"